import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function SportsTabs({
  idGroup = "tabs", // 1. Agregamos un ID por defecto para diferenciar las instancias
  futbolsala,
  baloncesto,
  tenis,
  ajedrez,
  baloncestofemenino,
  atletismo,
  futbolin,
  medallero,
  futbol9,
  ecuavoley,
  duatlon,
  natacion,
  hyrox,
}) {
  const allTabs = [
    {
      id: "futbol9",
      label: "Fútbol 9",
      emoji: "⚽",
      content: <div className="space-y-4">{futbol9}</div>,
      hasData: !!futbol9,
    },
    {
      id: "duatlon",
      label: "Duatlon",
      emoji: "🚴",
      content: <div className="space-y-4">{duatlon}</div>,
      hasData: !!duatlon,
    },
    {
      id: "natacion",
      label: "Natación",
      emoji: "🥽",
      content: <div className="space-y-4">{natacion}</div>,
      hasData: !!natacion,
    },
    {
      id: "hyrox",
      label: "Hyrox",
      emoji: "🏋️",
      content: <div className="space-y-4">{hyrox}</div>,
      hasData: !!hyrox,
    },

    {
      id: "ecuavoley",
      label: "Ecuavoley",
      emoji: "🏀",
      content: <div className="space-y-4">{ecuavoley}</div>,
      hasData: !!ecuavoley,
    },
    {
      id: "futbol",
      label: "Fútbol Sala Mixto",
      emoji: "⚽",
      content: <div className="space-y-4">{futbolsala}</div>,
      hasData: !!futbolsala,
    },
    {
      id: "baloncesto",
      label: "Baloncesto Masculino",
      emoji: "🏀",
      content: <div className="space-y-4">{baloncesto}</div>,
      hasData: !!baloncesto,
    },
    {
      id: "baloncestofemenino",
      label: "Baloncesto Femenino",
      emoji: "🏀",
      content: <div className="space-y-4">{baloncestofemenino}</div>,
      hasData: !!baloncestofemenino,
    },
    {
      id: "atletismo",
      label: "Atletismo",
      emoji: "🏃",
      content: <div className="space-y-4">{atletismo}</div>,
      hasData: !!atletismo,
    },
    {
      id: "tenis",
      label: "Tenis de mesa",
      emoji: "🏓",
      content: <div className="space-y-4">{tenis}</div>,
      hasData: !!tenis,
    },
    {
      id: "ajedrez",
      label: "Ajedrez",
      emoji: "♟️",
      content: <div className="space-y-4">{ajedrez}</div>,
      hasData: !!ajedrez,
    },
    {
      id: "futbolin",
      label: "Futbolín",
      emoji: "🕹️",
      content: <div className="space-y-4">{futbolin}</div>,
      hasData: !!futbolin,
    },
    {
      id: "medallero",
      label: "Medallero",
      emoji: "🥇",
      content: <div className="space-y-4">{medallero}</div>,
      hasData: !!medallero,
    },
  ];

  const availableTabs = allTabs.filter((tab) => tab.hasData);

  const [activeTab, setActiveTab] = useState(() => {
    return availableTabs.length > 0 ? availableTabs[0].id : null;
  });

  if (availableTabs.length === 0) {
    return (
      <div className="w-full max-w-6xl mx-auto p-12 text-center text-neutral-500 bg-white dark:bg-neutral-900 rounded-2xl shadow-xl border border-neutral-100 dark:border-neutral-800">
        No hay disciplinas deportivas disponibles en este momento.
      </div>
    );
  }

  return (
    <div className="w-full max-w-6xl mx-auto p-4 sm:p-6 bg-white dark:bg-neutral-900 rounded-2xl shadow-xl border border-neutral-100 dark:border-neutral-800">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 bg-neutral-100/80 dark:bg-neutral-800/60 p-1.5 rounded-xl mb-8 gap-1.5 w-full border border-neutral-200/40 dark:border-neutral-700/30">
        {availableTabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`relative flex items-center justify-center gap-2 w-full py-2.5 px-3 text-xs font-bold rounded-lg transition-colors duration-300 focus:outline-none z-10 h-10 select-none ${
                isActive
                  ? "text-white dark:text-amber-400"
                  : "text-neutral-500 dark:text-neutral-400 hover:text-neutral-800 dark:hover:text-neutral-200"
              }`}
            >
              {/* 2. SOLUCIÓN: El layoutId ahora es dinámico y único por grupo de pestañas */}
              {isActive && (
                <motion.div
                  layoutId={`active-tab-${idGroup}`}
                  className="absolute inset-0 bg-[#004270] dark:bg-neutral-800 rounded-lg -z-10 shadow-md border-b-2 border-amber-400"
                  transition={{ type: "spring", stiffness: 380, damping: 30 }}
                />
              )}

              <span
                className={`text-sm shrink-0 transition-transform duration-200 ${isActive ? "scale-110" : "opacity-80"}`}
              >
                {tab.emoji}
              </span>
              <span className="truncate text-left sm:text-center w-full tracking-tight">
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>

      <div className="relative min-h-[200px]">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ y: 12, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -12, opacity: 0 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
          >
            {availableTabs.find((t) => t.id === activeTab)?.content}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
